import { useEffect, useState } from 'react'
import { useUserData } from '../lib/useUserData.js'
import { useAuth } from '../context/AuthContext.jsx'
import { useToast } from '../context/ToastContext.jsx'
import Seo from '../components/Seo.jsx'

export default function Settings() {
  const { user } = useAuth()
  const { notifySettings, updateNotifySettings } = useUserData()
  const toast = useToast()

  // defaults when no row exists yet
  const [form, setForm] = useState({ dose_reminders: true, reminder_lead_days: 1, product_updates: false })
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (notifySettings && Object.keys(notifySettings).length) {
      setForm({
        dose_reminders: notifySettings.dose_reminders ?? true,
        reminder_lead_days: notifySettings.reminder_lead_days ?? 1,
        product_updates: notifySettings.product_updates ?? false,
      })
    }
  }, [notifySettings])

  const save = async (patch) => {
    const next = { ...form, ...patch }
    setForm(next)
    setSaving(true)
    const res = await updateNotifySettings(next)
    setSaving(false)
    if (res?.error) return toast(res.error, 'red')
    toast('Preferences saved', 'green')
  }

  return (
    <main className="page">
      <Seo title="Notification Settings | CalculateMyPeptides" noindex />
      <div className="container page-narrow">
        <h1 className="section-title">Notification settings</h1>
        <p className="section-sub">Choose which emails you’d like to receive. You can change these anytime.</p>

        <div className="card">
          <Toggle
            label="Dose reminders"
            desc="An email before your scheduled doses on the calendar."
            checked={form.dose_reminders}
            onChange={(v) => save({ dose_reminders: v })}
          />
          {form.dose_reminders && (
            <div className="set-sub">
              <label className="label sm">Remind me</label>
              <select className="select" style={{ maxWidth: 240 }} value={form.reminder_lead_days}
                onChange={(e) => save({ reminder_lead_days: Number(e.target.value) })}>
                <option value={0}>On the day of the dose</option>
                <option value={1}>1 day before</option>
                <option value={2}>2 days before</option>
              </select>
            </div>
          )}
          <div className="set-divider" />
          <Toggle
            label="Product updates"
            desc="Occasional news about new calculators and features."
            checked={form.product_updates}
            onChange={(v) => save({ product_updates: v })}
          />
        </div>

        <p className="muted small" style={{ marginTop: 14 }}>
          Signed in as {user?.email}. {saving ? 'Saving…' : 'Changes save automatically.'} Every email also
          includes a one-click unsubscribe link.
        </p>
      </div>
    </main>
  )
}

function Toggle({ label, desc, checked, onChange }) {
  return (
    <label className="set-row">
      <div className="set-info">
        <div className="set-label">{label}</div>
        <div className="set-desc">{desc}</div>
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        className={`switch ${checked ? 'on' : ''}`}
        onClick={() => onChange(!checked)}
      >
        <span className="switch-knob" />
      </button>
    </label>
  )
}
